import React, { useContext } from "react";

import axios from "axios";
import { useState, useEffect } from "react";
import Global from "../../util/Global";
import { useTranslation } from "react-i18next";
import { LoaderComponent } from "../../util/Loader";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
import OrderSaleList from "../../components/OrdersSales/OrderSaleList";
import { AlertContext } from "../../util/Alerter";
import NotFound from "../../components/NotFound";
import { CurrencyContext, filterSaleByRetailer } from "../../components/Utils";

const MesVentes = () => {
  const { t } = useTranslation();
  const [sales, setsales] = useState([])
  const { showAlert } = useContext(AlertContext)
  const { setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)
  const [isLoading, setisLoading] = useState(true);
  const { getCurrencyPrice } = useContext(CurrencyContext)


  const SALES_URL = Global.backend + "/index.php/api/commande/showSales";




  useEffect(() => {
    setpageNavLink({ path: "/dashboard", label: "navigation12.1" })
    setpageTitle("mySales")
    setalertTitle("")
    setnavLinks([])
  }, [])



  useEffect(() => {
    setisLoading(true)

    axios
      .post(SALES_URL)
      .then((response) => {

        const sales = response.data.map((sale) => {
          return filterSaleByRetailer(sale, getCurrencyPrice)
        })
        setsales(sales)

      }).catch((err) => {
        showAlert("error", t("request.errorFetchSales"))
      })
      .finally(() => {
        setisLoading(false);
      });
  }, []);


  return (
    <LoaderComponent isLoading={isLoading}>
      {!sales.length ? <NotFound /> : <OrderSaleList items={sales} isSale={true} />}
    </LoaderComponent>
  )

};

export default MesVentes;
